export default {
  trainingPlan: {
    title: 'Training Plans',
    subtitle: 'Choose your perfect training plan and start your journey to success',
    metaTitle: 'Training Plans - Running Wild',
    metaDescription: 'Comprehensive training plans for runners of all levels. From 5K to marathon, get personalized training schedules with detailed weekly workouts.',
    recommended: 'Recommended',
    weeks: 'Weeks',
    distance: 'Distance',
    targetTime: 'Target Time',
    startPlan: 'Start This Plan',
    backToPlans: 'Back to Plans',
    trainingZones: 'Training Zones',
    weeklySchedule: 'Weekly Schedule',
    selectWeek: 'Select Week',
    setGoal: 'Set Goal',
    setRaceGoal: 'Set Race Goal',
    goalDescription: 'Set your target finish time for the race day. This will help customize your training plan.',
    targetHours: 'Target Hours',
    hoursPlaceholder: 'Hours',
    minutesPlaceholder: 'Minutes',
    secondsPlaceholder: 'Seconds',
    saveGoal: 'Save Goal',
    cancel: 'Cancel',
    invalidTime: 'Please enter a valid time.',
    goalSaved: 'Goal saved successfully!',
    readyToStart: 'Ready to Start?',
    actionSubtitle: 'Choose your next step to begin your training journey',
    startTrainingDesc: 'Begin your training program',
    setGoalDesc: 'Define your target finish time',
    downloadPlanDesc: 'Save plan to your device',
    sharePlan: 'Share Plan',
    sharePlanDesc: 'Share with friends',
    goalSet: 'Goal Set',
    clearGoal: 'Clear Goal',
    goalCleared: 'Goal cleared successfully!',
    week: 'Week',
    startTraining: 'Start Training',
    downloadPlan: 'Download Plan',
    downloadSuccess: 'Training plan "{planName}" has been downloaded successfully!',
    downloadError: 'Please select a training plan first.',
    planOverview: 'Plan Overview',
    goalTime: 'Goal Time',
    goalStatus: 'Goal Status',
    active: 'Active',
    // Additional keys for TrainingPlan.vue
    targetPace: 'Target Pace',
    goalAdjusted: 'Goal-adjusted',
    noTraining: 'No training',
    recoveryAndRestDay: 'Recovery and rest day',
    days: {
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday'
    },
    startTrainingMessage: 'Starting your training plan!',
    shareError: 'No plan selected to share',
    shareCopied: 'Link copied to clipboard!',
    sharePrompt: 'Copy this link:'
  },
  eventDashboard: {
    title: 'Event Dashboard',
    filter: 'Filter & Search',
    level: 'Level',
    overall: 'Overall',
    female: 'Female',
    male: 'Male',
    team: 'Team',
    search: 'Search',
    searchPlaceholder: 'Enter athlete name...',
    ranking: 'Ranking',
    participants: '{count} participants',
    page: 'Page {current}/{total}',
    points: 'Points',
    actions: 'Actions',
    inspect: 'Inspect',
    cert: 'Cert',
    next: 'Next',
    prev: 'Prev',
    first: 'First',
    last: 'Last',
    results: 'results',
    join: 'Join',
    stats: 'Stats',
    total: 'Total',
    type: 'Type',
    name: 'Name',
    date: 'Date',
    km: 'Km',
    pace: 'Pace',
    report: 'Report',
    activityDetails: 'Activity Details',
    totalPoints: 'Total Points:',
    totalKm: 'Total Km:',
    totalDays: 'Total Days:',
    summaryByType: 'Summary by Type ({count} activities):',
    number: '#',
    teamName: 'Team Name',
    levelName: 'Level Name',
    eventName: 'Event Name',
    eventDates: '{from} - {to}',
    statusUpcoming: 'Upcoming',
    statusExpired: 'Ended',
    statusActive: 'Ongoing',
    activityList: 'Activity List',
    viewOnStrava: 'View on Strava',
    resetFilters: 'Reset All Filters',
    var: 'Var',
    io: 'I/O',
    dateTime: 'Date time',
    soiiReport: 'Soii/Report',
    inSportWeTrust: 'In sport we trust! Take it easy lah (^.^)',
    failedInspection: 'Failed to load inspection results.',
    loadingAthletes: 'Loading athletes...',
    times: 'times'
  },
  login: {
    brand: 'Nghiện Chạy Bộ',
    welcome: 'Welcome to the community!',
    instruction: 'Click Login with Strava to start your running journey with us, connect and share achievements with everyone!',
    loginWithStrava: 'Login with Strava',
    redirecting: 'Redirecting...',
    step1: 'Click the Login with Strava button as shown above',
    guideAlt: 'Login guide',
    step2: 'Select Authorize to allow nghienchaybo.com to sync your Strava data',
    step3: 'After that, your Strava data will be automatically synced to nghienchaybo.com',
    error: 'Login error',
    title: 'Login'
  },
  profile: {
    id: 'ID:',
    email: 'Email:',
    athlete_name: 'Name:',
    total_activities: 'Total activities:',
    proMember: 'Pro Member - Premium subscription active',
    noChallenges: 'No Challenges Yet',
    joinChallenges: 'Join exciting challenges to start your fitness journey!',
    editProfile: 'Edit Profile',
    save: 'Save',
    saving: 'Saving...',
    optional: 'Optional',
    emailAddress: 'Email Address',
    emailPlaceholder: 'Enter your email address',
    invalidEmail: 'Please enter a valid email address.',
    // Profile configuration fields
    age: 'Age',
    agePlaceholder: 'Enter your age',
    invalidAge: 'Please enter a valid age (1-120)',
    weight: 'Weight',
    weightPlaceholder: 'Enter your weight',
    invalidWeight: 'Please enter a valid weight (1-500 kg)',
    height: 'Height',
    heightPlaceholder: 'e.g., 168',
    heightHelp: 'Enter your height in centimeters (e.g., 168 cm)',
    invalidHeight: 'Please enter a valid height (50-300 cm)',
    gender: 'Gender',
    selectGender: 'Select gender',
    genderMale: 'Male',
    genderFemale: 'Female',
    genderUnknown: 'Unknown',
    invalidGender: 'Please select a gender',
    autoAnalyseAndShare: 'Auto Analyse & Share to Strava',
    autoAnalyseAndShareHelp: 'Automatically generate AI analysis and share to Strava when you create a new activity',
    trainingTarget: 'Training Target',
    trainingTargetHelp: 'Set your race goals to track your progress',
    targetFinishTime: 'Target Finish Time',
    targetFinishTimeHelp: 'e.g., For full marathon sub 4 hours, enter 4 hours 0 minutes',
    targetRaceDate: 'Target Race Date',
    targetRaceDateHelp: 'When is your target race? (Format: MM-DD-YYYY)',
    targetSportTypes: 'Target Sport Types',
    targetSportTypesHelp: 'Select the sports you want to train for (Hold Ctrl/Cmd to select multiple)',
    goalDescription: 'Goal Description',
    goalDescriptionPlaceholder: 'Describe your training goals, what you want to achieve, your target races, or any specific objectives...',
    goalDescriptionHelp: 'This description will be used by AI to provide more personalized training analysis',
    sportRunning: 'Running',
    sportCycling: 'Cycling',
    sportSwimming: 'Swimming',
    sportTriathlon: 'Triathlon',
    hours: 'Hours',
    minutes: 'Minutes',
    hoursPlaceholder: 'HH',
    minutesPlaceholder: 'MM',
    myActivities: 'My Activities',
    myChallenges: 'My Challenges',
    upcoming: 'Upcoming',
    ended: 'Ended',
    active: 'Active',
    start: 'Start',
    end: 'End',
    viewDetails: 'View Details',
    dashboard: 'Dashboard',
    myAchievement: 'My Achievement',
    loadingMoreChallenges: 'Loading more challenges...',
    loadingAchievement: 'Loading achievement...',
    noAchievementData: 'No achievement data available.',
    activityList: 'Activity List',
    type: 'Type',
    name: 'Name',
    date: 'Date',
    km: 'Km',
    movingTime: 'Time',
    pace: 'Pace',
    showStats: 'Show Stats',
    hideStats: 'Hide Stats',
    count: 'Count',
    block: 'Block',
    blocks: 'Blocks',
    points: 'Points',
    updateSuccess: 'Profile updated successfully!',
    updateFailed: 'Failed to update profile',
    success: 'Success',
    error: 'Error',
    validationError: 'Validation Error',
    pleaseFixValidationErrors: 'Please fix the validation errors before submitting',
    athleteNotFound: 'Athlete not found',
    pleaseLoginAgain: 'Please log in again to update your profile',
    redirectingToLogin: 'No authentication found. Redirecting to Strava login...',
    achievementLoadFailed: 'Failed to load achievement',
    changeAvatar: 'Change Avatar',
    uploadAvatar: 'Upload Avatar',
    dragDropOrClick: 'Drag and drop an image here, or click to select',
    supportedFormats: 'Supported formats: JPG, PNG, GIF (Max 5MB)',
    fileSizeError: 'File size must be less than 5MB',
    selectedFile: 'Selected File',
    noFileSelected: 'Please select a file to upload',
    avatarUploadSuccess: 'Avatar uploaded successfully!',
    avatarUploadFailed: 'Failed to upload avatar',
    sessionExpired: 'Your session has expired. Please log in again.',
    authenticationRequired: 'Authentication Required',
    aiGen: 'AI Gen',
    aiImageGen: 'Image Gen',
    aiVideoGen: 'Video Gen',
    aiTracklogStats: 'AI Tracklog Stats',
    dailyAiAnalysisLimitExceeded: 'You have reached your daily AI analysis limit. Please try again tomorrow.',
    aiAnalysisError: 'AI Analysis Error',
    aiAnalysisThinking: 'AI is thinking...',
    aiAnalysisThinkingDescription: 'Comparing your current activity with your recent public data.',
    comparisonPeriod: 'Comparison Period',
    activitiesAnalyzed: 'Activities Analyzed',
    loadingAiGen: 'Loading AI generation data...',
    tracklogList: 'Tracklog List',
    tracklogName: 'Tracklog Name',
    dateTime: 'Date Time',
    actions: 'Actions',
    noTracklogData: 'No tracklog data available.',
    aiGeneratedImage: 'AI Generated Image',
    aiGeneratedVideo: 'AI Generated Video',
    generatingImage: 'Generating AI image... please wait a moment or you can go to AI generation tab to see the progress',
    generatingVideo: 'Generating AI video... please wait a moment or you can go to AI generation tab to see the progress',
    aiGeneratedFor: 'AI Generated for',
    generatedOn: 'Generated on',
    downloadImage: 'Download Image',
    downloadVideo: 'Download Video',
    openInNewTab: 'Open in New Tab',
    shareImage: 'Share Image',
    shareVideo: 'Share Video',
    onlyMe: 'Only Me',
    makePublic: 'Make Public',
    privacyUpdated: 'Privacy updated',
    privacyUpdateFailed: 'Failed to update privacy',
    uploadSourceImage: 'Upload Source Image',
    dragDropImage: 'Drag and drop an image here or click to select',
    changeImage: 'Change Image',
    uploadingImage: 'Uploading image...',
    invalidFileType: 'Invalid file type. Please select an image file.',
    fileTooLarge: 'File too large. Maximum size is 10MB.',
    uploadFailed: 'Failed to upload file',
    videoNotSupported: 'Your browser does not support the video tag.',
    // AI History
    myAiHistory: 'My AI Gen History',
    loadingAiHistory: 'Loading AI generation history...',
    errorLoadingAiHistory: 'Failed to load AI generation history',
    noAiHistory: 'No AI Generation History',
    generateAiContent: 'Generate AI content for your activities to see them here!',
    refreshAiHistory: 'Refresh AI History',
    refresh: 'Refresh',
    startPolling: 'Auto-refresh',
    // Dashboard
    distance: 'Distance',
    time: 'Time',
    avgSpeed: 'Avg Speed',
    avgHR: 'Avg HR',
    elevation: 'Elevation',
    loading: 'Loading...',
    loadMore: 'Load More',
    noActivities: 'No Activities Found',
    noActivitiesDescription: 'You haven\'t participated in any events yet. Join some challenges to start tracking your activities!',
    errorLoadingActivities: 'Failed to load activities',
    stopPolling: 'Stop Auto-refresh',
    // No activities modal
    noActivitiesModalTitle: 'No Activities Found',
    tooFewActivities: 'Too Few Activities Found',

    noActivitiesModalMessage: 'You don\'t have any activities synced yet. Sync your Strava activities to see them here, or join events to track new activities.',
    tooFewActivitiesMessage: 'You don\'t have enough activities to generate AI content. Please sync your Strava activities to see them here, or join events to track new activities.',

    tooFewActivitiesModalSyncSuccess: 'Activities synced successfully!',
    noActivitiesModalSyncActivities: 'Sync All My Activities',

    tooFewActivitiesModalSyncActivities: 'Sync All My Activities',
    noActivitiesModalExploreEvents: 'Explore Events',

    tooFewActivitiesModalExploreEvents: 'Explore Events',
    noActivitiesModalClose: 'Close',

    tooFewActivitiesModalClose: 'Close',
    noActivitiesModalSyncing: 'Syncing activities...',

    tooFewActivitiesModalSyncing: 'Syncing activities...',
    noActivitiesModalSyncSuccess: 'Activities synced successfully!',
    noActivitiesModalSyncStarted: 'Activities sync started in background! This may take a few minutes.',

    tooFewActivitiesModalSyncStarted: 'Activities sync started in background! This may take a few minutes.',
    noActivitiesModalSyncError: 'Failed to sync activities',

    tooFewActivitiesModalSyncError: 'Failed to sync activities',
    syncInProgressTitle: 'Sync In Progress',

    noActivitiesModalSyncFeature: 'Sync all your Strava activities to see them here',
    tooFewActivitiesModalSyncFeature: 'Sync all your Strava activities to see them here',

    noActivitiesModalJoinEventsFeature: 'Join events with custom rules and challenges',
    tooFewActivitiesModalJoinEventsFeature: 'Join events with custom rules and challenges',

    noActivitiesModalTrackProgressFeature: 'Track your progress and achievements',
    tooFewActivitiesModalTrackProgressFeature: 'Track your progress and achievements',

    autoRefreshing: 'Auto-refreshing...',
    aiHistoryUpdated: 'AI history has been updated',
    updateNotification: 'Update',
    pollingStopped: 'Auto-refresh stopped due to errors',
    pollingError: 'Connection Error',
    activityId: 'Activity ID',
    contentType: 'Content Type',
    status: 'Status',
    contentUrl: 'Content URL',
    contentTitle: 'Content',
    contentText: 'Content',
    viewAnalysis: 'View Analysis',
    createdAt: 'Created At',
    updatedAt: 'Updated At',
    viewContent: 'View Content',
    noContent: 'No Content',
    previous: 'Previous',
    next: 'Next',
    showingResults: 'Showing {start}-{end} of {total} results',
    unknown: 'Unknown',
    aiStatus: {
      started: 'Started',
      finished: 'Finished',
      failed: 'Failed',
      processing: 'Processing',
      error: 'Error'
    },
    statusTitle: 'Status',
    makePrivate: 'Make Private',
    // Preview functionality
    preview: 'Preview',
    previewContent: 'Preview Content',
    open: 'Open',
    loadingContent: 'Loading content...',
    failedToLoadContent: 'Failed to load content',
    tapToZoom: 'Tap to zoom',
    daily_ai_generation_limit_exceeded: 'Daily AI generation limit exceeded. Please try again tomorrow. Run more activities to get more credits (coming soon ^.^)',
    // Privacy controls
    privacy: 'Privacy',
    public: 'Public',
    private: 'Private',
    makeContentPublic: 'Make Public',
    makeContentPrivate: 'Make Private',
    contentMadePublic: 'Content is now public',
    contentMadePrivate: 'Content is now private',
    notAvailable: 'N/A',
    // Additional missing keys
    uploadImageForAiImage: 'Upload Image for AI Generation',
    dragDropImageForAiImage: 'Drag and drop an image here or click to select for AI generation',
    uploadingAvatar: 'Uploading avatar...'
  },
  progress: {
    title: 'Progress Tracker',
    loading: 'Loading progress data...',
    totalDistance: 'Total Distance',
    totalTime: 'Total Time',
    activities: 'Activities',
    totalElevation: 'Total Elevation',
    avgPace: 'Avg Pace',
    avgHR: 'Avg Heart Rate',
    longestRun: 'Longest Run',
    longestRide: 'Longest Ride',
    byType: 'Activities by Type',
    weeklyTrend: 'Weekly Trend',
    noData: 'No activity data available for this period',
    errorLoadingProgress: 'Error loading progress data',
    unknown: 'Unknown',
    last7Days: 'Last 7 Days',
    last30Days: 'Last 30 Days',
    last90Days: 'Last 90 Days',
    eventPeriod: 'Event Period',
    customRange: 'Custom Range',
    vsPreviewPeriod: 'vs previous period',
    daysRemaining: 'days remaining',
    progressComplete: 'Complete'
  },
  eventDetail: {
    joinCode: 'Join code',
    level: 'Level',
    team: 'Team',
    personalTarget: 'Personal target',
    paceTarget: 'Target PACE (5m30)',
    paceFormatHelp: 'Format: 5m30 or 5m00',
    join: 'Join',
    dashboard: 'Dashboard',
    teamDashboard: 'Team Dashboard',
    upcoming: 'Upcoming',
    expired: 'Ended',
    active: 'Ongoing',
    scoringRules: 'Scoring Rules',
    error: 'Error',
    varDashboard: 'Summary Table',
    title: 'Event Detail',
    selectLevel: 'Please select your level',
    selectTeam: 'Please select your team',
    enterPaceTarget: 'Please enter your pace target',
    invalidPaceTarget: 'Please enter a valid pace target, e.g., 5p30 or 5p00',
    codeMismatch: 'Incorrect code / code mismatch'
  },
  nav: {
    brand: 'NCB',
    home: 'Home',
    events: 'Events',
    trainingPlans: 'Training Plans',
    gpxAnimator: 'GPX Animator',
    eventVar: 'Event Var',
    guide: 'Login Guide',
    login: 'Login',
    profile: 'Profile',
    profileLabel: 'Profile',
    logout: 'Logout',
    blog: 'Blog',
    about: 'About us',
    createEvent: 'Create Event'
  },
  events: {
    title: 'Events',
    noEvents: 'No events available',
    join: 'Join',
    upcoming: 'Upcoming',
    expired: 'Expired',
    error: 'Error',
    loading: 'Loading events...',
    loadMore: 'Load More Events'
  },
  home: {
    noEvents: 'No events available',
    noEventsDesc: 'Please check back later for upcoming events!',
    viewDetails: 'View details',
    newActivities: 'New Activities',
    athlete: 'Athlete',
    activity: 'Activity',
    type: 'Type',
    distance: 'Distance',
    topEvents: 'Top Events',
    upcoming: 'Upcoming',
    ended: 'Ended',
    active: 'Active',
    startDate: 'Start Date',
    subscriptionPlans: 'Subscription Plans',
    subscriptionDesc: 'Choose the perfect plan for your running journey',
    recommended: 'RECOMMENDED',
    month: 'month',
    save: 'Save',
    unlimitedActivities: 'Unlimited activities tracking',
    aiAnalysis: 'AI-powered analysis',
    prioritySupport: 'Priority support',
    subscribeNow: 'Subscribe Now',
    plan: 'Plan',
    duration: 'Duration',
    totalPrice: 'Total Price',
    pricePerMonth: 'Per Month',
    youSave: 'You Save',
    paymentInstructions: 'Payment Instructions',
    bankTransfer: 'Bank Transfer',
    bankName: 'Bank',
    accountNumber: 'Account Number',
    accountName: 'Account Name',
    amount: 'Amount',
    transferNote: 'Transfer Note (Important!)',
    transferNoteDesc: 'Please include this exact note in your transfer:',
    copy: 'Copy',
    noteWarning: 'Without this note, we cannot verify your payment!',
    scanQrCode: 'Scan QR Code',
    qrCodeDesc: 'Use your banking app to scan this QR code:',
    qrNote: 'QR code includes account details. Remember to add the transfer note!',
    activationTime: 'Activation Time',
    activationDesc: 'Your subscription will be activated within 24 hours after we verify your payment. You will see the PRO badge on your profile once activated.',
    activationContact: 'If you have any questions, please contact us at',
    enterStravaId: 'Enter Your Strava ID',
    stravaIdDesc: 'Please enter your Strava Athlete ID. You can find it in your Strava profile URL.',
    stravaIdPlaceholder: 'e.g., 12345678',
    invalidStravaId: 'Please enter a valid numeric Strava ID',
    howToFindStravaId: 'How to find your Strava ID:',
    goToProfile: 'Go to your profile',
    stravaIdInUrl: 'and look at the URL (e.g., strava.com/athletes/12345678)',
    subscribingAs: 'Subscribing as',
    stravaIdRequired: 'Please enter your Strava ID.',
    invalidStravaIdError: 'Please enter a valid numeric Strava ID.',
    missingInfo: 'Missing Information',
    invalidInput: 'Invalid Input',
    paymentNote: 'You will receive a notification once your subscription is activated.',
    rateLimitError: 'Too many requests. Please try again later.',
    errorContact: 'If the problem persists, please contact us at',
    cancel: 'Cancel',
    paymentMade: 'I Have Made the Payment',
    copiedToClipboard: 'Copied to clipboard!',
    paymentReceived: 'Payment Confirmation',
    paymentConfirmMessage: 'Thank you! Your subscription will be activated within 24 hours after we verify your payment.',
    activePlan: 'Active Plan',
    pendingPlan: 'Payment Pending',
    suspendedPlan: 'Subscription Suspended',
    status: 'Status',
    activeStatus: 'Active',
    pendingStatus: 'Pending',
    validPeriod: 'Valid Period',
    daysRemaining: 'Days Remaining',
    days: 'days',
    pendingMessage: 'Thank you for your payment! We are processing your subscription.',
    pendingTimeline: 'Your subscription will be activated within 24 hours after we verify your payment. You will receive a notification once it\'s active.',
    needHelp: 'Need help?',
    pendingContact: 'Contact our support team at',
    suspendedMessage: 'Your subscription has been suspended. Please choose a new plan below to continue enjoying premium features.',
    suspendedContact: 'If you have questions, please contact us at',
    paymentError: 'There was an error submitting your payment confirmation. Please contact support.',
    error: 'Error',
    endDate: 'End Date',
    heroTitle: 'Flexible, Customizable Event Rules for All Sports',
    heroSubtitle: 'Create events with custom pace, heart rate, time, and any Strava-supported sport.',
    getStarted: 'Get Started',
    seeHowItWorks: 'See How It Works',
    featuresTitle: 'Why Choose Our Platform?',
    featureCustomRules: 'Custom Rule Engine',
    featureCustomRulesDesc: 'Set pace, heart rate, time frame, and more. Make your event rules as flexible as you need.',
    featureMultiSport: 'Multi-Sport Support',
    featureMultiSportDesc: 'Not just running! We support swimming, biking, and any sport type from Strava.',
    featureRuleCustomization: 'Rule Customization',
    featureRuleCustomizationDesc: 'Customize pace, heart rate, elevation, active days, and more. Earn x2 or x3 points for running at special times!',
    featureTrainingPlans: 'Training Plans',
    featureTrainingPlansDesc: 'Professional training plans for Half Marathon and Full Marathon with structured workouts and goal setting.',
    trackYourGoal: 'Set a Goal',
    trackYourGoalDesc: 'Define your goal and chase it with silent persistence.',
    howItWorksTitle: 'How It Works',
    howStep1: 'Set up your event',
    howStep2: 'Define custom rules',
    howStep3: 'Invite participants',
    howStep4: 'Track results & celebrate',
    topAthletes: 'Top Athletes',
    topEventsSection: 'Top Events',
    participants: 'Participants',
    eventsCreated: 'Events Created',
    sportsSupported: 'Sports Supported',
    ctaTitle: 'Ready to create your own event?',
    ctaDesc: 'Start now and experience the most flexible event platform.',
    trainingPlansTitle: 'Professional Training Plans',
    trainingPlansSubtitle: 'Choose from our expert-designed training plans for Half Marathon and Full Marathon distances. Each plan includes structured workouts, goal setting, and progress tracking.',
    halfMarathonPlan: 'Half Marathon Plan',
    halfMarathonPlanDesc: '16-week structured training plan for 21.1km distance',
    fullMarathonPlan: 'Full Marathon Plan',
    fullMarathonPlanDesc: '16-week comprehensive training plan for 42.2km distance',
    weeks: 'Weeks',
    trainingDistance: 'Distance',
    trainingTargetTime: 'Target Time',
    startTrainingPlan: 'Start Training Plan',
    footerText: 'All rights reserved.',
    about: 'About',
    contact: 'Contact',
    latestActivity: 'Latest Activity',
    // Special Features Section
    specialFeatures: 'Special Features',
    specialFeaturesDesc: 'Discover our unique tools designed for runners',
    makeKorlorTitle: 'MakeKorlor',
    makeKorlorDesc: 'Create stunning animated route videos from your GPX files with music synchronization',
    trainingPlanTitle: 'Training Plans',
    trainingPlanDesc: 'Personalized training plans for 5K, 10K, half marathon, and marathon distances',
    uploadGpx: 'Upload GPX files',
    addMusic: 'Add background music',
    animateRoute: 'Animate your route',
    exportVideo: 'Export animated videos',
    weeklySchedules: 'Weekly schedules',
    goalSetting: 'Goal setting',
    progressTracking: 'Progress tracking',
    exportPlans: 'Export plans',
    tryMakeKorlor: 'Try MakeKorlor',
    startTraining: 'Start Training',
    // Login CTA Section
    redirectingToFeed: 'Redirecting to your activity feed...',
    joinCommunity: 'Join Our Running Community!',
    loginBenefit: 'Connect with fellow runners, track your progress, and access exclusive features',
    connectRunners: 'Connect with runners',
    trackProgress: 'Track your progress',
    exclusiveFeatures: 'Exclusive features',
    loginNow: 'Login with Strava',
    freeToJoin: 'It\'s free and takes just seconds!'
    ,
    // Subscription & AI Coach additions
    aiCoachTitle: 'Unlock your AI Running Coach',
    aiCoachSubtitle: 'Turn every run into actionable insights. Train smarter, avoid plateaus, and hit new PRs with personalized guidance.',
    seePlans: 'See Plans & Pricing',
    learnMore: 'Learn more',
    weeklyVolume: 'Weekly Volume',
    easyPace: 'Easy Pace',
    sleepRecovery: 'Recovery Score',
    formSignal: 'Form Signal',
    stable: 'Stable',
    compareTitle: 'Why go PRO?',
    free: 'Free',
    pro: 'PRO',
    freeBasicTracking: 'Basic activity tracking',
    freeHistory: 'Recent history only',
    freeCommunity: 'Community feed',
    proSmartInsights: 'Smart insights after every run',
    proPersonalPlans: 'Personalized training nudges',
    proFormSignals: 'Technique & effort signals',
    proTrendlines: 'Trendlines & progress tracking',
    proPrioritySupport: 'Priority support',
    faqTitle: 'Frequently Asked Questions',
    // AI hero points
    aiPointPersonalizedInsightsTitle: 'Personalized insights',
    aiPointPersonalizedInsightsDesc: 'Get simple, actionable takeaways after every run.',
    aiPointTrainSmarterTitle: 'Train smarter',
    aiPointTrainSmarterDesc: 'Adaptive nudges help you progress without overtraining.',
    aiPointSeeProgressTitle: 'See real progress',
    aiPointSeeProgressDesc: 'Clear trendlines reveal what’s truly improving.',
    aiPointStayMotivatedTitle: 'Stay motivated',
    aiPointStayMotivatedDesc: 'Milestones and streaks keep you consistent.',
    // How it works (subscription AI)
    howConnectTitle: 'Connect your activities',
    howConnectDesc: 'Keep running as usual. We sync and analyze automatically.',
    howAnalyzeTitle: 'AI analyzes patterns',
    howAnalyzeDesc: 'We detect trends in pace, effort, and consistency.',
    howGuidanceTitle: 'Get clear guidance',
    howGuidanceDesc: 'Short tips you can apply on your very next run.',
    // FAQ
    faqQ1: 'How does AI analysis help me run better?',
    faqA1P1: 'We summarize complex data into simple tips: what to do more, less, or differently.',
    faqA1P2: 'You will see patterns across weeks, not just single sessions.',
    faqQ2: 'Is PRO suitable for beginners?',
    faqA2P1: 'Yes. Guidance is written in plain language and focuses on simple next steps.',
    faqA2P2: 'It helps both new and experienced runners avoid plateaus.',
    faqQ3: 'What do I get after paying?',
    faqA3P1: 'Your subscription will be activated within 24 hours after verification.',
    faqA3P2: 'You will see a PRO badge and unlock AI insights automatically.',
    faqQ4: 'Can I cancel anytime?',
    faqA4P1: 'Yes. Your plan runs until the end of the paid period, then stops.',
    faqA4P2: 'No hidden fees.'
  },
  teamEventDashboard: {
    title: 'Team Event Dashboard',
    noTeams: 'No teams available',
    join: 'Join Team',
    team: 'Team',
    teams: 'Teams',
    members: 'Members',
    points: 'Points',
    rank: 'Rank',
    upcoming: 'Upcoming',
    expired: 'Expired',
    teamsCount: '{count} {teamLabel}',
    loadingMoreTeams: 'Loading more teams...',
    noTeamsFound: 'No teams found',
    noTeamsJoined: 'No teams have joined this event yet.',
    loadingTeams: 'Loading teams...'
  },
  eventVar: {
    loading: 'Loading team stats...',
    error: 'Error loading data',
    retry: 'Retry',
    export: 'Export CSV',
    exportCSV: 'Export to CSV',
    refresh: 'Refresh',
    searchPlaceholder: 'Search by name or team...',
    allTeams: 'All Teams',
    allGenders: 'All Genders',
    male: 'Male',
    female: 'Female',
    allActivityTypes: 'All Activity Types',
    clearFilters: 'Clear Filters',
    teamStats: 'Team Statistics',
    rank: 'Rank',
    athlete: 'Athlete',
    gender: 'Gender',
    team: 'Team',
    totalAthletes: '{count} athletes',
    showing: 'Showing {count} of {total} athletes',
    previous: 'Previous',
    next: 'Next',
    largeScreenTitle: 'Best Viewed on Large Screens',
    largeScreenMessage: 'This page contains detailed statistics and tables that are optimized for viewing on desktop computers and tablets. For the best experience, we recommend using a larger screen.',
    featureTable: 'Full table view with all data columns',
    featureFilters: 'Advanced search and filtering options',
    featureExport: 'Export data to CSV format',
    continueAnyway: 'Continue Anyway',
    teamDashboard: 'Team Dashboard',
    eventDashboard: 'Event Dashboard',
    inspectionResults: 'Inspection Results',
    noSimilarActivities: 'No similar activities found.',
    inspection: 'Inspection',
    close: 'Close',
    inspectionLoading: 'Analyzing tracklog...',
    inspectionSubtitle: 'This section shows groups of activities with similar routes or suspicious patterns. Each group may indicate possible duplicates or anomalies.',
    showingGroups: 'Showing {from}–{to} of {total} groups',
    pageSize: 'Page size:',
    jumpToPage: 'Page:',
    group: 'Group',
    activityName: 'Activity Name',
    teamName: 'Team Name',
    pace: 'Pace',
    distance: 'Distance',
    movingTime: 'Moving Time',
    elapsedTime: 'Elapsed Time',
    avgHR: 'AVG HR',
    avgWatts: 'AVG Watts',
    elevHigh: 'Elev High',
    elevLow: 'Elev Low',
    avgCadence: 'AVG Cadence'
  },
  eventMap: {
    loadingMap: 'Loading map...'
  },
  app: {
    brand: 'nghienchaybo.com',
    tagline: 'Virtual Sports | Health Tech - 2025',
    powered: 'Powered by Strava | In Beta Testing',
    home: 'Home',
    backToTop: 'Back to top',
    contactUs: 'Contact Us',
    email: 'Email',
    phone: 'Phone',
    affiliateTitle: 'Affiliate Sites',
    affiliateYoutube: '👨💻 Learn programming with Ahaxu 👨💻',
    affiliate42x: '42xChallenge.Com',
    copyright: 'All rights reserved.'
  },
  feed: {
    title: 'Activity Feed',
    loadMore: 'Load More Activities',
    welcomeBack: 'Welcome back, {name}!',
    athlete: 'Athlete',
    stayConnected: 'Stay connected with your running community',
    joinEvent: 'Join Event',
    profile: 'Profile',
    aiYourProfile: 'AI your profile',
    profileLabel: 'Profile',
    recentActivity: 'Recent Activity',
    loadingActivities: 'Loading activities...',
    aiGenerated: 'AI Generated',
    viewFullSize: 'View Full Size',
    noRecentActivities: 'No recent activities',
    followAthletes: 'Follow some athletes or join events to see activities here',
    exploreEvents: 'Explore Events',
    quickTools: 'Quick Tools',
    makeKorlor: 'MakeKorlor',
    trainingPlans: 'Training Plans',
    activityImage: 'Activity Image',
    activity: 'Activity',
    aiGeneratedImage: 'AI Generated Image',
    aiGeneratedVideo: 'AI Generated Video',
    videoNotSupported: 'Your browser does not support HTML5 video.'
  },
  makeKorlor: {
    title: 'GPX 3D Animator',
    subtitle: 'Visualize your GPX tracks with 3D animation and music sync',
    uploadGpx: 'Upload GPX File',
    uploadGpxPlaceholder: 'Choose a GPX file to animate...',
    addMusic: 'Add Music (Optional)',
    addMusicPlaceholder: 'Choose an audio file...',
    animationSpeed: 'Animation Speed:',
    markerSize: 'Marker Size:',
    play: 'Play',
    pause: 'Pause',
    reset: 'Reset',
    toggleSatellite: 'Toggle Satellite',
    toggleTerrain: 'Toggle Terrain',
    toggleStreet: 'Toggle Street',
    currentSpeed: 'Current Speed:',
    elevation: 'Elevation:',
    distance: 'Distance:',
    trackInfo: 'Track Information',
    totalDistance: 'Total Distance:',
    totalTime: 'Total Time:',
    avgSpeed: 'Average Speed:',
    maxSpeed: 'Maximum Speed:',
    loading: 'Processing GPX file...',
    gpxLoaded: 'GPX file loaded successfully!',
    musicLoaded: 'Music file loaded! Music will sync with animation speed.',
    defaultMusicLoaded: 'Default music loaded! Music will sync with animation speed.',
    errorLoadingGpx: 'Error loading GPX file:',
    errorLoadingMusic: 'Error loading music file:',
    noGpxFile: 'Please load a GPX file first!',
    noTrackData: 'No track data to export!',
    processing: 'Processing GPX file...',
    exportSuccess: 'Track data exported successfully!',
    speedUp: '🚀 Faster than average!',
    speedDown: '😌 Slower than average',
    startPoint: 'Start Point',
    endPoint: 'End Point',
    recordVideo: 'Record Video',
    stopRecording: 'Stop Recording',
    recording: 'Recording',
    recordedVideo: 'Recorded Video',
    videoNotSupported: 'Your browser does not support video playback.',
    downloadVideo: 'Download Video',
    shareVideo: 'Share Video',
    recordingStarted: 'Recording started! Select what you want to record when the browser prompts you.',
    recordingStopped: 'Recording stopped.',
    recordingCompleted: 'Video recording completed!',
    recordingNotSupported: 'Screen recording is not supported in your browser.',
    screenAccessDenied: 'Screen access was denied. Please allow screen sharing.',
    mapNotFound: 'Map not found. Please try again.',
    noVideoRecorded: 'No video has been recorded yet.',
    videoDownloaded: 'Video downloaded successfully!',
    videoShared: 'Video link copied to clipboard!',
    forceStopRecording: 'Force Stop Recording',
    forceStop: 'Force Stop',
    recordingForceStopped: 'Recording force stopped',
    noRecordingData: 'No recording data available',
    recordingError: 'Recording error: {error}',
    animationCompleted: 'Animation completed, stopping recording',
    autoStoppingRecording: 'Auto-stopping recording after animation',
    autoSelecting: 'Auto-Selecting',
    shouldAutoRecord: 'Should automatically record this tab',
    ifPrompted: 'If prompted',
    selectThisTab: 'Select "This tab" or "Current tab"'
  }
}
